'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 1281629883;
});
$p.b = (function() {
  return "Password";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "Password";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$, "be.doeraene.webcomponents.ui5.configkeys.InputType$Password$", ({
  gx: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Password$ };
